import React from 'react';
import AnteojosSubNav from './AnteojosSubNav';
import AnteojosTodos from '../views/AnteojosTodos';
import AnteojosTomados from '../views/AnteojosTomados';
import AnteojosPreparados from '../views/AnteojosPreparados';
import AnteojosLaboratorio from '../views/AnteojosLaboratorio';
import AnteojosParaRetirar from '../views/AnteojosParaRetirar';
import AnteojosEntregados from '../views/AnteojosEntregados';

const AnteojosLayout = ({ currentView, onViewChange }) => {
  const renderAnteojosView = () => {
    switch (currentView) {
      case 'anteojos-todos':
        return <AnteojosTodos />;
      case 'anteojos-tomados':
        return <AnteojosTomados />;
      case 'anteojos-preparados':
        return <AnteojosPreparados />;
      case 'anteojos-laboratorio':
        return <AnteojosLaboratorio />;
      case 'anteojos-para-retirar':
        return <AnteojosParaRetirar />;
      case 'anteojos-entregados':
        return <AnteojosEntregados />;
      default:
        return <AnteojosTodos />;
    }
  };

  return (
    <div>
      <AnteojosSubNav
        currentView={currentView}
        onViewChange={onViewChange}
      />
      {renderAnteojosView()}
    </div>
  );
};

export default AnteojosLayout;
